import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";

import {
  Progress,
  Button,
  Card,
  Space
} from '@lockerpm/design';

import {
  ArrowRightOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../components/items";

import rewardServices from "../../../../services/reward";
import common from "../../../../utils/common";

const GenerateCode = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const {
    className = '',
    totalPercent = 20,
    availablePercent = 0,
    remainPercent = 0,
    gennedPercent = 0,
    getCode = () => {},
    redeemCode = () => {}
  } = props;

  const locale = useSelector((state) => state.system.locale);

  const [promoCodes, setPromoCodes] = useState([]);

  useEffect(() => {
    getPromosCodes();
  }, [availablePercent, gennedPercent, remainPercent])

  const getPromosCodes = () => {
    rewardServices.get_promo_codes().then((res) => {
      setPromoCodes(res)
    }).catch(() => {
      setPromoCodes([])
    })
  }

  const progressDesc = useMemo(() => {
    if (availablePercent <= gennedPercent) {
      return t('rewards.no_discount', { percent: remainPercent });
    }
    if (availablePercent > 0 && gennedPercent === 0) {
      return t('rewards.progress', { percent: availablePercent });
    }
    if (availablePercent > gennedPercent) {
      return t('rewards.progress1', { percent: availablePercent, current_percent: gennedPercent });
    }
    if (gennedPercent === remainPercent) {
      return t('rewards.progress2')
    }
  }, [
    availablePercent,
    gennedPercent,
    remainPercent,
    locale
  ]);

  return (
    <div className={`generate-code ${className}`}>
      <div>
        {
          availablePercent > gennedPercent && <Progress
            percent={(availablePercent / totalPercent) * 100}
            showInfo={false}
            status="success"
            style={{ width: 260 }}
          />
        }
        {
          availablePercent <= gennedPercent && <Progress
            percent={(gennedPercent / totalPercent) * 100}
            showInfo={false}
            strokeColor="#A5ABB3"
            style={{ width: 260 }}
          />
        }
        <p className="mt-1">
          {progressDesc}
        </p>
      </div>
      {
        availablePercent > gennedPercent && <div className="flex items-center mt-6">
          <Button
            type={!(availablePercent - gennedPercent) ? '' : 'primary'}
            disabled={!(availablePercent - gennedPercent)}
            onClick={() => getCode()}
          >
            {t('rewards.get_code.title')}
          </Button>
          <div className="ml-2">
            <Trans
              i18nKey={'rewards.get_code.note'}
              values={{
                percent: remainPercent,
              }}
              components={{
                span: <span className="text-primary"/>
              }}
            />
          </div>
        </div>
      }
      {
        promoCodes.length > 0 && <div className="mt-3">
          <p className="mb-2 font-semibold">{ t('rewards.get_code.your_codes') }</p>
          <Space size={[16, 16]} wrap>
            {
              promoCodes.map((code) => <div key={code.id}>
                <Card
                  className="w-[300px]"
                  bordered={false}
                  bodyStyle={{ padding: 20 }}
                >
                  <div className="flex items-center justify-between">
                    <TextCopy
                      className="font-bold"
                      value={code.code}
                    />
                    <p className="font-bold uppercase">{t('common.expiration')}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-warning">{t('rewards.note2', { percent: code.value })}</span>
                    <span>{common.convertDateTime(code.expired_time, 'MMMM Do YYYY')}</span>
                  </div>
                </Card>
                <div
                  className="mt-3 flex items-center text-primary font-semibold cursor-pointer"
                  onClick={() => redeemCode(code.code)}
                >
                  {t('rewards.get_code.redeem_code')}
                  <ArrowRightOutlined className="ml-2"/>
                </div>
              </div>)
            }
          </Space>
        </div>
      }
    </div>
  );
}

export default GenerateCode;